// Status icon/color mapping for step timeline nodes, per the design system rules:
// pending=gray circle, in_progress=pulsing red ring, completed/approved/passed=green
// check, rejected/failed=red X, skipped=gray dash.
export const STEP_STATUS_META = {
  pending: { label: 'Pending', className: 'border-2 border-gray-300 bg-white text-gray-400', symbol: '' },
  in_progress: { label: 'In Progress', className: 'bg-primary animate-pulse ring-4 ring-primary-light text-white', symbol: '' },
  completed: { label: 'Completed', className: 'bg-green-500 text-white', symbol: '✓' },
  approved: { label: 'Approved', className: 'bg-green-500 text-white', symbol: '✓' },
  passed: { label: 'Passed', className: 'bg-green-500 text-white', symbol: '✓' },
  rejected: { label: 'Rejected', className: 'bg-red-500 text-white', symbol: '✕' },
  failed: { label: 'Failed', className: 'bg-red-500 text-white', symbol: '✕' },
  skipped: { label: 'Skipped', className: 'bg-gray-300 text-white', symbol: '–' },
};

export function stepStatusMeta(status) {
  return STEP_STATUS_META[status] || STEP_STATUS_META.pending;
}
